import { Box, List, ListItem, ListItemText, Stack } from '@mui/material';
import React, { memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { updateUserAccessMessage } from 'src/components/common/AccessMessage';
import { usePermissionWrapper } from 'src/components/common/hooks/usePermissionWrapper';
import { store } from 'src/store';
import { setDocumentDetail } from 'src/store/documentDetail';
import { setUserDocPermissions } from 'src/store/User';
import DocManagementService from '../../documentUpload/service/DocManagementService';

/**
 * Component to display most recent documents.
 *
 * @param props Props from parent component.
 * @returns Recent document component.
 */
const MostRecentDocsComponent = (props: any) => {
  const { dataGridComponent, documentToDisplay, study, previousStudyValue, country, site } = props;
  const [dense, setDense] = React.useState<boolean>(false);
  const [loadingRecentDocs, setLoadingRecentDocs] = React.useState<any>(false);
  const [recentDocs, setRecentDocs] = React.useState([]);
  const dispatch = useDispatch();
  const { checkPermission } = usePermissionWrapper();
  const docService = new DocManagementService();
  const isfLevel = 'Site';

  /**
   * On recent document selected, check the permission and open the document in document viewer.
   *
   * @param documentDetails Selected document details.
   */
  const onRecentDocumentSelected = async (documentDetails: any) => {
    const response: any = await docService.getDocAccessPermissions(documentDetails);
    if (response.data != null && response.data.length > 0) {
      const docAccessPermissions: any = response.data.map((item: any) => item.permission);
      dispatch(setUserDocPermissions(docAccessPermissions));
      if (checkPermission('view_document_details')) {
        documentToDisplay(documentDetails);
        setDocumentDetail(dispatch, [documentDetails]);
        dataGridComponent(false);
      }
    } else {
      updateUserAccessMessage({ status: 403, dispatch: store.dispatch });
    }
  };

  /**
   * Fetch most recent documents based on user specific access.
   */
  const getRecentDocumentDetails = async () => {
    setLoadingRecentDocs(true);
  
    const response: any = await docService.getRecentDocumentsByUser(
      study,
      country,
      site,
      isfLevel,
      process.env.REACT_APP_NAME,
      'ISF Landing Page'
    );
    if (response?.data) {
      const documentDataTotal = response?.data?.selected_data?.map((el: any) => {
        el.file_master.fmId = el.file_master.id;
        el.document_data.fileId = el.file_master.id;
        el.file_master.docFormat = el.file_master.isf_doc_type;
        el.document_data.hashed_uri_key = el.hashed_uri_key;
        return el;
      });
      const comData = documentDataTotal.map(
        (resp: { document_data: any; file_master: any }) => [{ ...resp.file_master, ...resp.document_data }][0]
      );
      setRecentDocs(comData);
    } else {
      setRecentDocs([]);
    }
    setLoadingRecentDocs(false);
  };

  // useEffect(() => {
  //   setDense(false);
  //   getRecentDocumentDetails();
  // }, []);

  useEffect(() => {
    setDense(false);
    if (site && site !== '--') {
      getRecentDocumentDetails();
    } else {
      setRecentDocs([]);
    }
  }, [site]);

  return (
    <>
    <h3 style={{ marginTop: '0px', marginBottom: '12px'}}>Most Recent Documents</h3>
    <Box className="roundBorderedBox OutlinedVariantForm" sx={{ p: 2, flexGrow: 1, mb: 1 }}>
      {/* <h4>Most Recent Documents</h4> */}
      <List
        component="nav"
        dense={dense}
        className="recentDocList"
        aria-label="Recent Documents List"
        sx={{
          bgcolor: 'background.paper',
          position: 'relative',
          overflow: 'auto',
          height: 280,
          '& ul': { padding: 0 }
        }}
      >
        {recentDocs?.length > 0 &&
          recentDocs.map((item: any, i: number) => (
            <ListItem key={i} button divider onClick={() => onRecentDocumentSelected(item)}>
              <ListItemText primary={item.isf_document_name} title= {`Document: ${item.isf_document_name}`} />
            </ListItem>
          ))}
        {!recentDocs?.length && !loadingRecentDocs && (
          <Stack height="100%" alignItems="center" justifyContent="center">
            No rows
          </Stack>
        )}
        {!recentDocs?.length && loadingRecentDocs && (
          <Stack height="100%" alignItems="center" justifyContent="center">
            Loading...
          </Stack>
        )}
      </List>
    </Box>
    </>
  );
};
export default memo(MostRecentDocsComponent);
